import { createApp } from 'vue';
import router from './router.js';
import VueEasyLightbox from 'vue-easy-lightbox'
import directives from "./directives/";

import App from './App.vue';
import BaseButton from './components/Base/BaseButton.vue';
import BaseInput from './components/Base/BaseInput.vue';
import BaseNumber from './components/Base/BaseNumber.vue';
import BaseRange from './components/Base/BaseRange.vue';
import BaseFileInput from './components/Base/BaseFileInput.vue';
import BaseTextArea from './components/Base/BaseTextArea.vue';
import BaseSelect from './components/Base/BaseSelect.vue';
import BaseCheckBox from './components/Base/BaseCheckBox.vue';
import BaseRadio from './components/Base/BaseRadio.vue';
import BaseSpinner from './components/Base/BaseSpinner.vue';
import BaseNote from './components/Base/BaseNote.vue';
import BaseAlert from './components/Base/BaseAlert.vue';
import StyledText from './components/StyledText.vue';

import './assets/sass/index.scss'

const app = createApp(App);
app.use(router);
app.use(VueEasyLightbox);
directives(app);

// Global components
app.component('BaseSpinner', BaseSpinner);
app.component('BaseButton', BaseButton);
app.component('BaseInput', BaseInput);
app.component('BaseNumber', BaseNumber);
app.component('BaseRange', BaseRange);
app.component('BaseFileInput', BaseFileInput);
app.component('BaseTextArea', BaseTextArea);
app.component('BaseCheckBox', BaseCheckBox);
app.component('BaseRadio', BaseRadio);
app.component('BaseSelect', BaseSelect);
app.component('BaseNote', BaseNote);
app.component('BaseAlert', BaseAlert);
app.component('StyledText', StyledText);
app.mount('#app');
